module.exports = __webpack_public_path__ + "static/media/Map_1.a3ebc020.png";